import Img from "components/atoms/Img";
import FaqsGroup from "components/molecules/FaqsGroup";
import Banner from "components/organisms/Banner";
import ContactUs from "components/organisms/ContactUs";

const Component = ({ dataJson }) => {
  return (
    <>
      <Banner
        minHeightBanner="banner-min-h-569"
        breadcrumbs={dataJson.breadcrumbs}
        title={"Order Process"}
        titleProps={{
          className: "banner-default-title mb-6 lg:mb-10 capitalize",
          textColor: "banner-title-default-color",
        }}
        leftClassName="lg:col-7"
        rightClassName="lg:col-5"
        rightContent={
          <Img
            src={`/assets/images/common/${dataJson.banner_image}`}
            wrapper={{
              className: "bbc-banner-image-country",
            }}
            className="w-full"
            width={622}
            height={400}
            priority={true}
            alt="banner-img"
          />
        }
        bgColor={"bg-bbc-useful-links"}
      ></Banner>
      <section>
        <div className="container mt-10 lg:mt-20">
          <FaqsGroup
            data={dataJson.dataOrderProcess.map((item, index) => ({
              ...item,
              name: `<span class='font-semibold text-md text-bbc-brand-700'>${
                index + 1
              }.
                ${item.name}
                </span>`,
            }))}
            buttonClass={"!pl-0"}
            panelClass={"!pl-0"}
          />
        </div>
      </section>
      <section>
        <ContactUs />
      </section>
    </>
  );
};

export default Component;
